export enum Status {
  SUPPLIER_QUEUE_STATUS_WAITING = "SUPPLIER_QUEUE_STATUS_WAITING", // Ожидание в очереди
  SUPPLIER_QUEUE_STATUS_AT_GATE = "SUPPLIER_QUEUE_STATUS_AT_GATE", // Приглашен на ворота
  SUPPLIER_QUEUE_STATUS_UNLOADING_FINISHED = "SUPPLIER_QUEUE_STATUS_UNLOADING_FINISHED", // Разгрузка окончена
  SUPPLIER_QUEUE_STATUS_DEPARTED = "SUPPLIER_QUEUE_STATUS_DEPARTED", // Покинул территорию склада
}
